export var isDarkTheme = function isDarkTheme(appearance) {
  return appearance === 'dark';
};